module.exports = ".table-filter {\r\n    text-align: left;\r\n}\r\n\r\n.table-filter-input {\r\n    width: 50%;\r\n    margin-left: 5px;\r\n    margin-bottom: 5px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/training-session-detail/training-session-detail.component.css
// module id = ./src/app/components/training-session-detail/training-session-detail.component.css
// module chunks = main